import React from 'react';
import PropTypes from 'prop-types';
import { css } from '@bd/bdui-styles/emotion';
import { buildThumbnailUrl } from '@bd/bdcore-utilities';
import { get } from 'lodash';

import ContactModal from './ContactModal';
import { colors } from '../styles';

const styles = css`
  position: relative;
  .InsideHeader_background {
    height: auto;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    position: relative;
    height: 310px;
    @media(min-width: 992px) {
      height: 580px;
    }
  }
  .InsideHeader_h1Wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    z-index: 1;
    padding: 20px;
  }
  .InsideHeader_h1 {
    font-weight: 300;
    /* font-size: 38px; */
    font-size: 52px;
    color: ${colors.white};
    /* letter-spacing: 0.88px; */
    letter-spacing: 1.31px;
    text-align: center;
    /* line-height: 38px; */
    line-height: 51px;
    padding: 0 0 25px 0;
    position: relative;
    text-transform: capitalize;
    @media(min-width: 992px) {
      padding: 132px 0 43px 0;
      /* font-size: 64px;
      letter-spacing: 1.69px;
      line-height: 65px; */
      font-size: 75px;
      line-height: 81px;
      letter-spacing: 1.5px;
    }
    &::after {
      content: '';
      width: 75px;
      height: 2px;
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      background-color: ${colors.color1};
      @media(min-width: 992px) {
        width: 125px;
        height: 3px;
      }
    }
  }
  .InsideHeader_overlay {
    background-image: linear-gradient(180deg, rgba(30,30,30,0.80) 0%, rgba(30,30,30,0.20) 48%);
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
  .ContactModal_button{
    @media(min-width: 768px){
      cursor: pointer;
      position: absolute;
      bottom: 53px;
      right: 64px;
      height: 64px;
      width: 64px;
      background-color: ${colors.color1};
      background-image: url('/images/icons/icon-bubble.svg');
      background-size: 50%;
      background-position: center;
      background-repeat: no-repeat;
      z-index:2;
      border-radius: 100%;
    }
  }
`;

function InsideHeaderCommunity({ h1, background }) {
  let backgroundImage;
  if (background) {
    backgroundImage = buildThumbnailUrl(get(background, 'contentUrl'), { width: 2000, height: 2000 });
  }
  if (!background) {
    backgroundImage = '/images/default-header.jpg';
  }
  return (
    <div className={styles}>
      <ContactModal>
        <div className="ContactModal_button" />
      </ContactModal>
      <div style={{ backgroundImage: `url('${backgroundImage}')` }} className="d-flex InsideHeader_background">
        <span className="InsideHeader_overlay" />
        <div className="InsideHeader_h1Wrapper">
          <h1 className="InsideHeader_h1">{h1}</h1>
        </div>
      </div>
    </div>
  );
}

InsideHeaderCommunity.propTypes = {
  h1: PropTypes.string.isRequired,
  background: PropTypes.object,
};

InsideHeaderCommunity.defaultProps = {
  background: null,
};

export default InsideHeaderCommunity;



// WEBPACK FOOTER //
// ./src/components/InsideHeader.js